module.exports = __webpack_public_path__ + "img/roll4.72fcafbd.png";